export default __webpack_public_path__ + "images/icons/arrow-top-913a4a123ad0a2364c4c7bd4f76cccef.svg";